import styled, { css } from 'styled-components';

// Styles
import { hoverCapable } from '../../../../../../styles/hover';

// Styled Components — se reusan los compartidos de las tablas de gestión
import { Container, Tr } from '../../../summaryTables/SummaryTablesStyles';

/**
 * Layout de las dos tablas: EN FILA (activas | inactivas), igual que
 * UsersManagementTable. En pantallas estrechas se apilan solas.
 *
 * `TableContainer` NO se redefine aquí: se importa el compartido de
 * SummaryTablesStyles, como hace Usuarios.
 */
export const ContainerTable = styled(Container)`
  display: flex;
  gap: 9.8rem;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
    gap: 4rem;
  }
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: 3.2rem;
  }
`;

export const ActiveCompaniesTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  flex: 1;
  width: 57.2rem;
  max-width: 90.1rem;

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const InactiveCompaniesTableContainer = styled(
  ActiveCompaniesTableContainer
)``;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spaces.m}rem;
  div:last-child {
    flex: 1;
  }
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.paleGrey};
  ${({ indeterminate, checked }) => css`
    Td {
      ${!indeterminate && {
        opacity: 0.2,
      }}
      ${checked && {
        opacity: 1,
      }}
    }
  `}
`;

/**
 * Botón cuadrado garnet de 4rem: el mismo de SwapUserButton / ActionButton de
 * Equipos. Sirve tanto para las flechas de intercambio como para las acciones
 * de fila.
 */
const SquareGarnetButton = styled.button`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.white};
  min-height: 4rem;
  min-width: 4rem;
  width: 4rem;
  border: none;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.garnet};
  cursor: pointer;

  /* Solo con puntero fino: en táctil el :hover se queda pegado tras
     el toque (ver styles/hover.ts). */
  ${hoverCapable} {
    &:hover:not(:disabled) {
      opacity: 0.9;
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: ${({ theme }) => theme.opacity.disabled};
  }
`;

/** ⮕ bajo la tabla de ACTIVAS: mueve la seleccionada a inactivas. */
export const SwapCompanyButtonRight = styled(SquareGarnetButton)`
  align-self: end;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    align-self: flex-start;
  }
`;

/** ⬅ bajo la tabla de INACTIVAS: la devuelve a activas. */
export const SwapCompanyButtonLeft = styled(SquareGarnetButton)``;

export const ActionCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

export const ActionButton = styled(SquareGarnetButton)`
  min-height: 3.2rem;
  min-width: 3.2rem;
  width: 3.2rem;
  font-size: 1.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ActionIcon = styled.img`
  width: 1.6rem;
  height: 1.6rem;
`;
